<script>
    import { preventDefault } from 'svelte/legacy';

import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import * as m from '@app/paraglide/messages.js';

let applyAll = $state(false);
let style = $state("Pop-On");

function updateCaptionStyle(){
    console.log(applyAll);
    if (applyAll){
        eventGroupState[projectState.selected].events.forEach((event, index, events) =>{
            eventGroupState[projectState.selected].events[index].style = style;
        });
    } else {
        eventGroupState[projectState.selected].selected.forEach(eventIndex =>{
            eventGroupState[projectState.selected].events[eventIndex].style = style;
        })
    }
    
    toast.push(m.caption_style_updated({ style }), {
        classes: ["toast-success"]
    });

    insertHistoryAction({
        name: "update caption style", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    hideModal();
}
</script>

<div class="modal fade {modalState.selected === 'captionStyle' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="captionStyleModalTitle"
    aria-describedby="captionStyleModalDesc"
    tabindex="-1" 
    id="captionStyleModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="captionStyleModalTitle">{m.caption_style()}</h4>
                <button type="button" class="btn-close" id="closeStyleModal" aria-label={m.close_dialog()} onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <p id="captionStyleModalDesc" class="visually-hidden">{m.caption_style_description()}</p>
                <form onsubmit={preventDefault(updateCaptionStyle)}>
                    <div class="mb-3">
                        <label class="form-label" for="captionStyleSelect">{m.caption_style()}</label>
                        <select class="form-select" id="captionStyleSelect" bind:value={style} aria-describedby="styleHelpText">
                            <option value="Pop-On" selected="">{m.caption_style_pop_on()}</option>
                            <option value="Roll-Up 2">{m.caption_style_roll_up_2()}</option>
                            <option value="Roll-Up 3">{m.caption_style_roll_up_3()}</option>
                            <option value="Roll-Up 4">{m.caption_style_roll_up_4()}</option>
                            <option value="Paint-On">{m.caption_style_paint_on()}</option>             
                        </select>
                        <div id="styleHelpText" class="form-text">{m.caption_style_help()}</div>
                    </div>                    
                    <div class="mb-3 form-check">
                        <input type="checkbox" class="form-check-input" id="applyToAll" bind:checked={applyAll} aria-describedby="applyAllHelp">
                        <label class="form-check-label" for="applyToAll">{m.apply_to_all()}</label>
                        <div id="applyAllHelp" class="form-text">{m.apply_caption_style_all_help()}</div>
                    </div>
                    <div class="float-end">
                        <button class="btn btn-primary" id="updateStyleBtn" onclick={updateCaptionStyle} type="button">{m.update_style()}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
